<template>
    <BaseDialog
        :showDialog="!!dialog.show"
        maxDialogWidth="760"
        maxCardHeight="760"
        :headline="dialog.pattern && dialog.pattern.id ? 'lang_GENERAL_CAPTION_EDITING_ENTRY' : 'lang_GENERAL_CAPTION_NEW_ENTRY'"
        :close="close"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid v-if="dialog.show">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="pattern.pattern"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_SETTINGS_PATTERNS_PATTERN')"
                            :hint="$t('lang_PUBLISHING_USAGE_CAPTION_SETTINGS_PATTERNS_PATTERN_HINT')"
                            persistent-hint
                            :error-messages="errors.pattern"
                            class="usage-pattern-field"
                            :alvqa="alvqa + '-textfield-pattern'"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-text-field
                            v-model="pattern.example"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_SETTINGS_PATTERNS_EXAMPLE')"
                            :hint="$t('lang_PUBLISHING_USAGE_CAPTION_SETTINGS_PATTERNS_EXAMPLE_HINT')"
                            persistent-hint
                            :error-messages="errors.example"
                            :alvqa="alvqa + '-textfield-example'"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-select
                            v-model="pattern.numbering"
                            :items="numberings"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_SETTINGS_PATTERNS_NUMBERING')"
                            :error-messages="errors.numbering"
                            :alvqa="alvqa + '-dropdown-numbering'"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            v-model="pattern.priority"
                            type="number"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_SETTINGS_PATTERNS_PRIORITY')"
                            :hint="$t('lang_PUBLISHING_USAGE_CAPTION_SETTINGS_PATTERNS_PRIORITY_HINT')"
                            persistent-hint
                            :error-messages="errors.priority"
                            :alvqa="alvqa + '-textfield-priority'"
                        />
                    </v-col>
                    <v-col cols="5">
                        <v-select
                            v-model="pattern.dataType"
                            :items="dataTypes"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_DATA_TYPE')"
                            :error-messages="errors.dataType"
                            :alvqa="alvqa + '-dropdown-data-type'"
                        />
                    </v-col>
                    <v-col cols="4" class="d-flex align-center">
                        <v-checkbox
                            v-model="pattern.isActive"
                            :label="$t('lang_PUBLISHING_USAGE_CAPTION_SETTINGS_PATTERNS_ACTIVE')"
                            color="generalCheckbox"
                            hide-details
                            :alvqa="alvqa + '-checkbox-active'"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="pattern.description"
                            :label="$t('lang_GENERIC_CAPTION_DESCRIPTION')"
                            counter="255"
                            :error-messages="errors.description"
                            :alvqa="alvqa + '-textfield-description'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-spacer />
            <BaseButton label="lang_GENERAL_BUTTON_CANCEL" color="buttonCancel" class="mr-2" :alvqa="alvqa + '-button-cancel'" @click="close" />
            <BaseButton
                label="lang_GENERAL_BUTTON_SAVE"
                :loading="!!dialog.saving"
                :disabled="!pattern.pattern || !pattern.example"
                :alvqa="alvqa + '-button-save'"
                @click="$store.dispatch('saveUsageEpisodePattern')"
            />
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import { DATA_TYPES, NUMBERINGS } from '@/pages/2_publishing/8_usage/usageOptions'

/** Add or change one of the account's episode patterns. The API checks it as on import (it must compile, have an
 *  "episode" group and read its own example) and names the field to fix. */
export default {
    name: 'UsageEpisodePatternDialog',
    components: { BaseDialog, BaseButton },
    data() {
        return { alvqa: 'account-settings-usage-episode-pattern-dialog' }
    },
    computed: {
        dialog() { return this.$store.getters.getUsageEpisodePatternDialog },
        pattern() { return this.dialog.pattern || {} },
        errors() { return this.dialog.errors || {} },
        numberings() { return NUMBERINGS.map(o => ({ value: o.value, text: this.$t(o.text) })) },
        dataTypes() {
            return [{ value: null, text: this.$t('lang_GENERIC_CAPTION_ALL') }, ...DATA_TYPES.map(o => ({ value: o.value, text: this.$t(o.text) }))]
        }
    },
    methods: {
        close() { this.$store.commit('setUsageEpisodePatternDialog', { show: false }) }
    }
}
</script>

<style scoped>
.usage-pattern-field ::v-deep input {
    font-family: monospace;
}
</style>
